import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router';

import { ROUTES } from '~shared/config/routes';

import { isAuthorisedAtom } from '@breezeventures/web-ph-client-auth/model';
import { useAtomValue } from 'jotai';

export const RequireAuth = ({ children }: PropsWithChildren) => {
  const isAuthorised = useAtomValue(isAuthorisedAtom);

  if (isAuthorised) {
    return children;
  }

  return <Navigate to={ROUTES.login} replace />;
};
